<template>
  <div>
    <div class="col-lg-12">
      <div class="d-flex flex-column">
        <busqueda-b-l />
      </div>
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            <h5 class="text-center">Resultados</h5>
          </div>
        </div>
        <div class="card-body">
          <div class="col-lg-12">
            <div class="card contenedorFiltros">
              <div class="card-body">
                <busqueda-b-l-resultado-tabla/>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="row">
              <div class="col-md-6">
                <div class="card contenedorFiltros">
                  <div class="card-body">
                    <bills-of-landing-tabla />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card contenedorFiltros">
                  <div class="card-body">
                    <containers-tabla/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapActions } from "vuex";
import BusquedaBL from "../../components/busqueda/lineas/BusquedaBL";
import BillsOfLandingTabla from "../../components/tablas/lineas/BillsOfLandingTabla";
import BusquedaBLResultadoTabla from "../../components/tablas/lineas/BusquedaBLResultadoTabla";
import ContainersTabla from "../../components/tablas/lineas/ContainersTabla.vue";

export default {
  components: {
    BusquedaBL,
    BillsOfLandingTabla,
    BusquedaBLResultadoTabla,
    ContainersTabla
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["AccionCambiar"]),

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
  },
  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
  },
};
</script>

<style></style>
